const es = {
  "common": {
    "save": "Guardar",
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "edit": "Editar",
    "add": "Añadir",
    "search": "Buscar",
    "loading": "Cargando...",
    "error": "Error",
    "success": "Éxito",
    "confirm": "Confirmar",
    "back": "Atrás",
    "next": "Siguiente",
    "previous": "Anterior",
    "close": "Cerrar",
    "submit": "Enviar",
    "update": "Actualizar",
    "view": "Ver",
    "download": "Descargar",
    "upload": "Subir",
    "select": "Seleccionar",
    "all": "Todo",
    "none": "Ninguno",
    "yes": "Sí",
    "no": "No"
  },
  "nav": {
    "dashboard": "Panel",
    "createAd": "Crear Anuncio",
    "campaigns": "Campañas",
    "insights": "Análisis",
    "contextiq": "ContextIQ",
    "adGallery": "Galería de Anuncios",
    "university": "Universidad",
    "managedServices": "Servicios Gestionados",
    "resources": "Recursos",
    "settings": "Configuración",
    "signOut": "Cerrar Sesión",
    "help": "Ayuda y Recursos"
  },
  "header": {
    "searchPlaceholder": "Buscar campañas, creativos...",
    "notifications": "Notificaciones",
    "viewAllNotifications": "Ver todas las notificaciones",
    "accountSettings": "Configuración de Cuenta",
    "manageSubscription": "Gestionar Suscripción",
    "upgradePlan": "Mejorar Plan",
    "updateProfile": "Actualizar Perfil",
    "takeTour": "Hacer el Tour",
    "language": "Idioma"
  },
  "dashboard": {
    "title": "Panel",
    "welcome": "Bienvenido de nuevo",
    "overview": "Resumen",
    "recentCampaigns": "Campañas Recientes",
    "topPerformingAds": "Anuncios Más Exitosos",
    "quickActions": "Acciones Rápidas",
    "createNewAd": "Crear Nuevo Anuncio",
    "viewCampaigns": "Ver Campañas",
    "viewInsights": "Ver Análisis",
    "impressions": "Impresiones",
    "clicks": "Clics",
    "ctr": "CTR",
    "spend": "Gasto",
    "conversions": "Conversiones",
    "revenue": "Ingresos",
    "performance": "Rendimiento",
    "thisMonth": "Este Mes",
    "lastMonth": "Mes Pasado",
    "contextiqWidget": {
      "title": "Análisis de ContextIQ",
      "brandMatches": "Coincidencias de Marca",
      "alignmentScore": "Puntuación de Alineación",
      "topOpportunities": "Mejores Oportunidades",
      "viewAll": "Ver Todo"
    }
  },
  "campaigns": {
    "title": "Campañas",
    "subtitle": "Gestiona y monitorea tus campañas publicitarias",
    "createCampaign": "Crear Campaña",
    "allCampaigns": "Todas las Campañas",
    "active": "Activa",
    "paused": "Pausada",
    "completed": "Completada",
    "draft": "Borrador",
    "scheduled": "Programada",
    "status": "Estado",
    "budget": "Presupuesto",
    "startDate": "Fecha de Inicio",
    "endDate": "Fecha de Fin",
    "noCampaigns": "No hay campañas todavía",
    "createFirst": "Crea tu primera campaña para comenzar"
  },
  "insights": {
    "title": "Análisis",
    "subtitle": "Analiza el rendimiento de tus campañas",
    "campaigns": "Campañas",
    "creatives": "Creativos",
    "audience": "Audiencia",
    "dateRange": "Rango de Fechas",
    "export": "Exportar",
    "metrics": {
      "totalImpressions": "Impresiones Totales",
      "totalClicks": "Clics Totales",
      "averageCtr": "CTR Promedio",
      "totalSpend": "Gasto Total",
      "costPerClick": "Costo por Clic",
      "conversionRate": "Tasa de Conversión"
    }
  },
  "contextiq": {
    "title": "ContextIQ",
    "subtitle": "Segmentación contextual impulsada por IA",
    "brandAnalysis": "Análisis de Marca",
    "contentMatching": "Coincidencia de Contenido",
    "opportunities": "Oportunidades",
    "safetyScore": "Puntuación de Seguridad de Marca",
    "alignmentScore": "Puntuación de Alineación",
    "analyzeUrl": "Analizar URL",
    "enterUrl": "Ingresa URL para analizar",
    "analyze": "Analizar",
    "results": "Resultados",
    "noResults": "Sin resultados todavía",
    "startAnalyzing": "Ingresa una URL arriba para comenzar a analizar"
  },
  "gallery": {
    "title": "Galería de Anuncios",
    "subtitle": "Explora y gestiona tus activos creativos",
    "uploadNew": "Subir Nuevo",
    "allCreatives": "Todos los Creativos",
    "images": "Imágenes",
    "videos": "Videos",
    "html5": "HTML5",
    "templates": "Plantillas",
    "sortBy": "Ordenar por",
    "newest": "Más Reciente",
    "oldest": "Más Antiguo",
    "name": "Nombre",
    "noCreatives": "No hay creativos todavía",
    "uploadFirst": "Sube tu primer creativo para comenzar"
  },
  "university": {
    "title": "Universidad Adventive",
    "subtitle": "Domina la publicidad interactiva",
    "courses": "Cursos",
    "certifications": "Certificaciones",
    "resources": "Recursos",
    "progress": "Tu Progreso",
    "completedCourses": "Cursos Completados",
    "inProgress": "En Progreso",
    "startLearning": "Comenzar a Aprender",
    "continueLearning": "Continuar Aprendiendo",
    "viewCourse": "Ver Curso",
    "certificate": "Certificado"
  },
  "managedServices": {
    "title": "Servicios Gestionados",
    "subtitle": "Deja que nuestros expertos creen tus anuncios",
    "newRequest": "Nueva Solicitud",
    "activeRequests": "Solicitudes Activas",
    "completedRequests": "Solicitudes Completadas",
    "requestStatus": {
      "pending": "Pendiente",
      "inProgress": "En Progreso",
      "review": "En Revisión",
      "completed": "Completada",
      "needsInput": "Necesita Información"
    },
    "submitRequest": "Enviar Solicitud",
    "requestDetails": "Detalles de la Solicitud"
  },
  "settings": {
    "title": "Configuración",
    "subtitle": "Gestiona las preferencias de tu cuenta",
    "profile": "Perfil",
    "organization": "Organización",
    "team": "Equipo",
    "notifications": "Notificaciones",
    "security": "Seguridad",
    "billing": "Facturación",
    "preferences": "Preferencias",
    "language": "Idioma",
    "timezone": "Zona Horaria",
    "theme": "Tema",
    "darkMode": "Modo Oscuro",
    "lightMode": "Modo Claro",
    "systemDefault": "Sistema por Defecto",
    "restartTour": "Reiniciar Tour de la Plataforma",
    "restartTourDesc": "Haz un tour guiado de las funciones de la plataforma",
    "profileInfo": {
      "title": "Información del Perfil",
      "subtitle": "Actualiza tus datos personales y preferencias",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "email": "Correo Electrónico",
      "phone": "Teléfono",
      "changePhoto": "Cambiar Foto",
      "photoHint": "JPG, PNG o GIF. Máx 2MB."
    },
    "organizationInfo": {
      "title": "Detalles de la Organización",
      "subtitle": "Gestiona la información de tu organización",
      "name": "Nombre de la Organización",
      "type": "Tipo de Organización",
      "industry": "Industria",
      "website": "Sitio Web",
      "address": "Dirección"
    },
    "teamMembers": {
      "title": "Miembros del Equipo",
      "subtitle": "Gestiona tu equipo",
      "inviteMember": "Invitar Miembro",
      "role": "Rol",
      "admin": "Administrador",
      "editor": "Editor",
      "viewer": "Visualizador",
      "pending": "Pendiente"
    },
    "notificationPrefs": {
      "title": "Preferencias de Notificación",
      "subtitle": "Elige cómo quieres ser notificado",
      "campaignUpdates": "Actualizaciones de Campaña",
      "campaignUpdatesDesc": "Recibe notificaciones cuando las campañas se activen, pasen o completen",
      "performanceReports": "Informes de Rendimiento",
      "performanceReportsDesc": "Recibe resúmenes de rendimiento diarios o semanales",
      "creativeApprovals": "Aprobaciones de Creativos",
      "creativeApprovalsDesc": "Recibe notificaciones cuando los creativos sean aprobados o necesiten revisión",
      "usageAlerts": "Alertas de Uso",
      "usageAlertsDesc": "Recibe notificaciones cuando te acerques o excedas los límites de impresiones",
      "pushNotifications": "Notificaciones Push",
      "pushNotificationsDesc": "Recibe notificaciones en tiempo real en el navegador",
      "weeklyDigest": "Resumen Semanal",
      "weeklyDigestDesc": "Recibe un resumen semanal de la actividad de tu cuenta"
    },
    "securitySettings": {
      "title": "Configuración de Seguridad",
      "subtitle": "Gestiona la seguridad de tu cuenta",
      "changePassword": "Cambiar Contraseña",
      "changePasswordDesc": "Actualiza tu contraseña regularmente por seguridad",
      "twoFactor": "Autenticación de Dos Factores",
      "twoFactorDesc": "Añade una capa extra de seguridad a tu cuenta",
      "notEnabled": "No habilitado",
      "enabled": "Habilitado",
      "activeSessions": "Sesiones Activas",
      "currentSession": "Sesión Actual",
      "activeNow": "Activo ahora"
    },
    "billingSettings": {
      "title": "Facturación",
      "overview": "Resumen",
      "usage": "Uso",
      "invoices": "Facturas",
      "payments": "Pagos",
      "planHistory": "Historial del Plan",
      "currentPlan": "Plan Actual",
      "changePlan": "Cambiar Plan",
      "paymentMethod": "Método de Pago",
      "billingInfo": "Información de Facturación",
      "updatePayment": "Actualizar Método de Pago",
      "impressionsUsed": "Impresiones Usadas",
      "cpmRate": "Tarifa CPM",
      "overage": "Excedente",
      "overageCost": "Costo del Excedente"
    },
    "saveChanges": "Guardar Cambios",
    "changesSaved": "Cambios guardados exitosamente"
  },
  "tour": {
    "welcome": {
      "title": "¡Bienvenido a Adventive!",
      "description": "Hagamos un tour rápido para ayudarte a comenzar con la plataforma. Aprenderás cómo crear anuncios, gestionar campañas y acceder a análisis poderosos."
    },
    "dashboard": {
      "title": "Tu Panel",
      "description": "Este es tu centro de comando. Ve métricas clave, campañas recientes y acciones rápidas en un solo lugar. El panel te da una visión en tiempo real del rendimiento de tu publicidad."
    },
    "createAd": {
      "title": "Crea Tu Primer Anuncio",
      "description": "Haz clic aquí para comenzar a construir anuncios interactivos y atractivos. Nuestro constructor de arrastrar y soltar facilita crear anuncios de medios enriquecidos sin programación.",
      "action": "Comienza creando tu primer anuncio"
    },
    "campaigns": {
      "title": "Gestiona Campañas",
      "description": "Organiza y rastrea todas tus campañas publicitarias. Establece presupuestos, horarios y opciones de segmentación. Monitorea el rendimiento en tiempo real."
    },
    "insights": {
      "title": "Análisis Poderosos",
      "description": "Profundiza en el rendimiento de tus campañas. Analiza impresiones, clics, tasas de engagement y comportamiento de la audiencia con análisis detallados."
    },
    "contextiq": {
      "title": "Inteligencia ContextIQ",
      "description": "Nuestra segmentación contextual impulsada por IA te ayuda a alcanzar la audiencia correcta en el momento correcto. Analiza contenido, encuentra alineaciones de marca y descubre oportunidades."
    },
    "gallery": {
      "title": "Galería de Anuncios",
      "description": "Accede a todos tus creativos en un solo lugar. Previsualiza, duplica, edita o archiva tus anuncios. Mantén tu biblioteca creativa organizada y accesible."
    },
    "managedServices": {
      "title": "Servicios Gestionados",
      "description": "¿Necesitas ayuda? Nuestro equipo de expertos puede construir anuncios personalizados para ti. Envía una solicitud y nos encargaremos del trabajo creativo mientras te enfocas en la estrategia."
    },
    "university": {
      "title": "Universidad Adventive",
      "description": "Mejora tus habilidades con nuestros recursos de aprendizaje. Accede a tutoriales, mejores prácticas y cursos de certificación para convertirte en un experto en publicidad interactiva."
    },
    "complete": {
      "title": "¡Estás Listo!",
      "description": "Estás listo para comenzar a crear anuncios interactivos increíbles. Si necesitas ayuda en cualquier momento, consulta nuestra sección de Recursos o contacta al soporte."
    },
    "skipTour": "Saltar tour",
    "getStarted": "Comenzar"
  },
  "plan": {
    "base": "Básico",
    "professional": "Profesional",
    "enterprise": "Empresarial",
    "upgrade": "Mejorar",
    "current": "Plan Actual",
    "perMonth": "/mes"
  },
  "brands": {
    "currentView": "Vista Actual",
    "allBrands": "Todas las Marcas",
    "selectBrand": "Seleccionar Marca",
    "addBrand": "Añadir Marca",
    "noBrands": "No hay marcas añadidas todavía",
    "addBrandsHint": "Añade marcas para gestionar múltiples clientes"
  },
  "errors": {
    "somethingWentWrong": "Algo salió mal",
    "tryAgain": "Por favor intenta de nuevo",
    "notFound": "Página no encontrada",
    "unauthorized": "Acceso no autorizado",
    "networkError": "Error de red"
  },
  "time": {
    "justNow": "Ahora mismo",
    "minutesAgo": "hace {{count}} min",
    "hoursAgo": "hace {{count}} hora",
    "hoursAgo_plural": "hace {{count}} horas",
    "daysAgo": "hace {{count}} día",
    "daysAgo_plural": "hace {{count}} días"
  }
};

export default es;
